// Default properties for IhmTelemetryJSLib
// https://code.amazon.com/packages/IhmTelemetryJSLib

import { EnvironmentDetail } from '@utils/EnvironmentDetailUtils';
import { DeviceDetails } from '@utils/DeviceDetails';
import { IhmAssociateToolsCoreServiceClient } from '@services/coralservices/serviceClients/IhmAssociateToolsCoreServiceClient';
import { AuthenticatedRequestsClient } from '@src/services/AuthenticatedRequestsClient';

async function getRegion() {
    return EnvironmentDetail.getRegion();
}

async function getDomain() {
    return EnvironmentDetail.getDomain();
}

async function getLocation() {
    return EnvironmentDetail.getStoreId();
}

async function getLocationIdType() {
    return EnvironmentDetail.getStoreIdType();
}

async function getDevice() {
    // CandyCane
    if (EnvironmentDetail.isAndroid()) {
        try {
            const deviceDetails: any = await DeviceDetails.getDeviceDetails();
            return (deviceDetails?.deviceSerialNumber as string) ?? 'CANDYCANE';
        } catch (error) {
            return 'CANDYCANE';
        }
    }

    // Velocity
    if (EnvironmentDetail.isVelocityBrowser(window)) {
        return 'VELOCITY';
    }

    // Browser
    return 'BROWSER';
}

async function getUsername() {
    try {
        const userDetails = await IhmAssociateToolsCoreServiceClient.getInstance().getUserAlias(EnvironmentDetail.getStoreId());
        return (userDetails?.body?.userAlias as string) ?? 'UNKNOWN';
    } catch (error) {
        return 'UNKNOWN';
    }
}

function getClient() {
    return {
        async handle(request: Request) {
            return AuthenticatedRequestsClient.crossFrameRequestRaw(
                {
                    url: request.url,
                    method: request.method,
                    headers: {
                        ...request.headers,
                    },
                    body: await request.json(),
                    withCredentials: false,
                },
                {
                    sensitive: true,
                },
            );
        },
    };
}

export const DefaultTelemetryConfig = () => {
    return {
        environment: {
            getRegion,
            getDomain,
            getLocation,
            getLocationIdType,
        },
        user: {
            getDevice,
            getUsername,
        },
        client: getClient(),
    };
};
